module.exports = __webpack_public_path__ + "img/dianxin.3da227c7.jpg";